// 런타임 오류를 기기에 쌓는다(최근 50개, localStorage 링버퍼). 서버로 보내지 않는다(goals.md 로컬 우선).
// 창 오류·미처리 Promise·Vue 컴포넌트 오류를 잡는다. 내용(일기 등)은 담지 않고 메시지·스택만.
import { reactive } from 'vue'

const KEY = 'mp-errlog'
const MAX = 50

export interface ErrEntry { t: string; src: string; msg: string; stack?: string }

function load(): ErrEntry[] {
  try { const v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : [] } catch { return [] }
}
export const errorState = reactive<{ list: ErrEntry[] }>({ list: load() })

function persist() {
  try { localStorage.setItem(KEY, JSON.stringify(errorState.list.slice(-MAX))) } catch { /* 저장 공간 없음 등 무시 */ }
}

export function logError(src: string, msg: unknown, stack?: string) {
  const e: ErrEntry = { t: new Date().toISOString(), src, msg: String(msg ?? '').slice(0, 600), stack: stack ? String(stack).slice(0, 2500) : undefined }
  errorState.list.push(e)
  if (errorState.list.length > MAX) errorState.list.splice(0, errorState.list.length - MAX)
  persist()
}
export function clearErrors() { errorState.list.splice(0); persist() }

export function installErrorHandlers(app?: { config: { errorHandler?: unknown } }) {
  window.addEventListener('error', (e) => {
    const err = (e as ErrorEvent).error
    logError('window', (e as ErrorEvent).message || err?.message || e, err?.stack)
  })
  window.addEventListener('unhandledrejection', (e) => {
    const r = (e as PromiseRejectionEvent).reason
    logError('promise', r?.message ?? r, r?.stack)
  })
  if (app) {
    app.config.errorHandler = (err: any, _inst: unknown, info: string) => {
      logError('vue', `${err?.message ?? err} @ ${info}`, err?.stack)
      console.error(err) // 콘솔에도 남긴다
    }
  }
}
